import { CustomCell, CustomRenderer, GridCellKind } from "@glideapps/glide-data-grid";
import { IComboBoxOptionGrid, IComboBoxProject, ItipoConceptoGrid } from "../../Components/CargaPorTabla/InterfaceTabla";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";

export interface DropdownMultiSelectCellProps {
  readonly kind: "dropdown-multiselect-cell";
  readonly value: IComboBoxOptionGrid[];
  readonly options: IComboBoxOptionGrid[] | ItipoConceptoGrid[] | IComboBoxProject[];
  readonly placeholder?: string;
  readonly disabled?: boolean;
  readonly width?: string;
  readonly id: string;
  readonly entity?: any;
  readonly className?: string;
  readonly displayData: any;
  readonly onChange:(option: any, id: string) => void | Promise<void>;
}

export type DropdownMultiSelectCell = CustomCell<DropdownMultiSelectCellProps>;

const CustomMenu = (p) => {
  const { Menu } = components;
  const { children, ...rest } = p;
  return <Menu {...rest}>{children}</Menu>;
};

const Wrap = (props) => {
  return <div>{props.children}</div>;
};

const PortalWrap = (props) => {
  return <div>{props.children}</div>;
};

export const DropdownMultiSelectRenderer: CustomRenderer<DropdownMultiSelectCell> = {
  kind: GridCellKind.Custom,

  isMatch: (c): c is DropdownMultiSelectCell =>
    c.kind === GridCellKind.Custom &&
    (c.data as any).kind === "dropdown-multiselect-cell",

  draw: (args, cell) => {
    const { ctx, theme, rect } = args;
    const { displayData, placeholder, value } = cell.data;

    ctx.save();
    ctx.beginPath();
    ctx.rect(rect.x, rect.y, rect.width, rect.height);
    ctx.clip();

    const padding = 6;
    const chipPaddingX = 8;
    const chipPaddingY = 4;
    const chipMargin = 4;
    let x = rect.x + theme.cellHorizontalPadding;
    const y = rect.y + rect.height / 2;

    const dataToRender = value?.length ? value : [];

    if (dataToRender.length === 0) {

      ctx.fillStyle = theme.textLight;
      ctx.textBaseline = "middle";
      ctx.fillText(placeholder ?? "", x, y);

    } else {

      for (const item of dataToRender) {

        const label = item.label ?? item.value ?? "";
        ctx.font = "12px sans-serif";
        const textWidth = ctx.measureText(label).width;

        const chipWidth = textWidth + chipPaddingX * 2;
        const chipHeight = 20;
        const chipY = y - chipHeight / 2;

        ctx.shadowColor = "transparent";
        ctx.shadowBlur = 0;

        ctx.fillStyle = "#f1f1f1";
        ctx.beginPath();
        ctx.roundRect(x, chipY, chipWidth, chipHeight, 6);
        ctx.fill();

        ctx.fillStyle = "black";
        ctx.textBaseline = "middle";
        ctx.fillText(label, x + chipPaddingX, y);

        x += chipWidth + chipMargin;
        if (x > rect.x + rect.width - 30) break;
      }
    }

    ctx.restore();
    return true;
  },

  provideEditor: () => {
    return (p) => {
      const { data } = p.value;
      const { value, placeholder, disabled, options, displayData } = data;

      const handlerOnChange = (newValue) => {
        if (newValue) {
          data.onChange(newValue, data.id);
          p.onFinishedEditing();
        }
      };

      return (
        <Wrap>
          <CreatableSelect
            isMulti={true}
            className="basic-multi-select"
            classNamePrefix={placeholder}
            defaultValue={value}
            isDisabled={disabled}
            isClearable={true}
            isSearchable={true}
            options={options}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
              Menu: (props) => (
                <PortalWrap>
                  <CustomMenu className={"click-outside-ignore"} {...props} />
                </PortalWrap>
              ),
            }}
            onChange={(newValue, actionMeta) => {
              handlerOnChange(newValue);
            }}
            formatCreateLabel={(inputValue) => `Crear: "${inputValue}"`}
            menuPortalTarget={document.getElementById("portal")}
            menuPlacement="auto"
            autoFocus={true}
            openMenuOnFocus={true}
            styles={{
              control: (provided) => ({
                ...provided,
                border: "none",
                boxShadow: "none",
                backgroundColor: "transparent",
              }),
              menu: (provided) => ({
                ...provided,
                border: "none",
                boxShadow: "none",
              }),
              option: (provided, state) => ({
                ...provided,
                fontSize: "13px",
              }),
              singleValue: (provided) => ({
                ...provided,
                fontSize: "13px",
              }),
            }}
          />
        </Wrap>
      );
    };
  },
};